export const VIDEO_SESSION_ACTIVE = 'video-session-active';
export type VideoOverlaySizing = 'compact' | 'sidebar' | 'fullscreen';
export const AINotesLabel = 'AI notes';
